import { EvaluationMilestoneCreate } from 'src/screens/shared/project/details/effectivity-management/evaluation-milestone/edit/EvaluationMilestoneCreate'

export const PfKapEvaluationMilestoneCreatePage = () => {
  return <EvaluationMilestoneCreate baseUrl="/pf-kap" />
}
